import { DifficultyLevel } from '../../../shared/enums';

export enum PlacesEnum {
  MANOR = 'manor',
  BUILDING = 'building',
  PARK = 'park',
  STREET = 'street',
  BRIDGE = 'bridge',
  THEATER = 'theater',
  ZOO = 'zoo',
  MOSKINO = 'moskino',
  MONUMENT = 'monument',
  METRO_STATION = 'metro_station',
}

export const PlaceToName: Record<PlacesEnum, string> = {
  [PlacesEnum.MANOR]: 'Усадьба',
  [PlacesEnum.BUILDING]: 'Здание',
  [PlacesEnum.PARK]: 'Парк',
  [PlacesEnum.STREET]: 'Улица',
  [PlacesEnum.BRIDGE]: 'Мост',
  [PlacesEnum.THEATER]: 'Театр',
  [PlacesEnum.ZOO]: 'Московский зоопарк',
  [PlacesEnum.MOSKINO]: 'Кинопарк Москино',
  [PlacesEnum.MONUMENT]: 'Монумент',
  [PlacesEnum.METRO_STATION]: 'Станция метро',
};

export const PlaceToNamePlural: Record<PlacesEnum, string> = {
  [PlacesEnum.MANOR]: 'Усадьбы',
  [PlacesEnum.BUILDING]: 'Здания',
  [PlacesEnum.PARK]: 'Парки',
  [PlacesEnum.STREET]: 'Улицы',
  [PlacesEnum.BRIDGE]: 'Мосты',
  [PlacesEnum.THEATER]: 'Театры',
  [PlacesEnum.ZOO]: 'Московский зоопарк',
  [PlacesEnum.MOSKINO]: 'Кинопарк Москино',
  [PlacesEnum.MONUMENT]: 'Монументы',
  [PlacesEnum.METRO_STATION]: 'Станции метро',
};

export type TGameType = 'fragments' | 'metro';

interface DifficultyResources {
  icons: Record<DifficultyLevel, string>;
  colors: Record<DifficultyLevel, { fill: string; underlayFill: string }>;
  text: {
    singular: Record<DifficultyLevel, string>;
    plural?: Record<DifficultyLevel, string>;
  };
  staticResources: {
    images: string[];
    audio: string[];
  };
}

export const GAME_CONFIG: Record<TGameType, DifficultyResources> = {
  fragments: {
    icons: {
      [DifficultyLevel.VERY_EASY]: require('../../../assets/images/fragments/levels/estates.png'),
      [DifficultyLevel.EASY]: require('../../../assets/images/fragments/levels/buildings.svg').default,
      [DifficultyLevel.MEDIUM]: require('../../../assets/images/fragments/levels/parks.png'),
      [DifficultyLevel.HARD]: require('../../../assets/images/fragments/levels/streets.svg').default,
      [DifficultyLevel.VERY_HARD]: require('../../../assets/images/fragments/levels/bridges.svg').default,
      [DifficultyLevel.PRO]: require('../../../assets/images/fragments/levels/theatres.svg').default,
      [DifficultyLevel.MASTER]: require('../../../assets/images/fragments/levels/moscow-zoo.svg').default,
      [DifficultyLevel.EXPERT]: require('../../../assets/images/fragments/levels/moskino.svg').default,
      [DifficultyLevel.GENIUS]: require('../../../assets/images/fragments/levels/monuments.svg').default,
      [DifficultyLevel.LEGEND]: require('../../../assets/images/fragments/levels/metro-stations.svg').default,
    },
    colors: {
      [DifficultyLevel.VERY_EASY]: { fill: '#FFD12C', underlayFill: '#E09705' },
      [DifficultyLevel.EASY]: { fill: '#0095FF', underlayFill: '#1856F2' },
      [DifficultyLevel.MEDIUM]: { fill: '#57BD0F', underlayFill: '#438A10' },
      [DifficultyLevel.HARD]: { fill: '#FF7760', underlayFill: '#DC5944' },
      [DifficultyLevel.VERY_HARD]: { fill: '#87DC4B', underlayFill: '#51BB24' },
      [DifficultyLevel.PRO]: { fill: '#FF690C', underlayFill: '#C55713' },
      [DifficultyLevel.MASTER]: { fill: '#0FBEA9', underlayFill: '#0A8374' },
      [DifficultyLevel.EXPERT]: { fill: '#E317D5', underlayFill: '#A30BB5' },
      [DifficultyLevel.GENIUS]: { fill: '#8138F6', underlayFill: '#4C13A8' },
      [DifficultyLevel.LEGEND]: { fill: '#F38FFE', underlayFill: '#C75CD4' },
    },
    text: {
      singular: {
        [DifficultyLevel.VERY_EASY]: PlaceToName[PlacesEnum.MANOR],
        [DifficultyLevel.EASY]: PlaceToName[PlacesEnum.BUILDING],
        [DifficultyLevel.MEDIUM]: PlaceToName[PlacesEnum.PARK],
        [DifficultyLevel.HARD]: PlaceToName[PlacesEnum.STREET],
        [DifficultyLevel.VERY_HARD]: PlaceToName[PlacesEnum.BRIDGE],
        [DifficultyLevel.PRO]: PlaceToName[PlacesEnum.THEATER],
        [DifficultyLevel.MASTER]: PlaceToName[PlacesEnum.ZOO],
        [DifficultyLevel.EXPERT]: PlaceToName[PlacesEnum.MOSKINO],
        [DifficultyLevel.GENIUS]: PlaceToName[PlacesEnum.MONUMENT],
        [DifficultyLevel.LEGEND]: PlaceToName[PlacesEnum.METRO_STATION],
      },
      plural: {
        [DifficultyLevel.VERY_EASY]: PlaceToNamePlural[PlacesEnum.MANOR],
        [DifficultyLevel.EASY]: PlaceToNamePlural[PlacesEnum.BUILDING],
        [DifficultyLevel.MEDIUM]: PlaceToNamePlural[PlacesEnum.PARK],
        [DifficultyLevel.HARD]: PlaceToNamePlural[PlacesEnum.STREET],
        [DifficultyLevel.VERY_HARD]: PlaceToNamePlural[PlacesEnum.BRIDGE],
        [DifficultyLevel.PRO]: PlaceToNamePlural[PlacesEnum.THEATER],
        [DifficultyLevel.MASTER]: PlaceToNamePlural[PlacesEnum.ZOO],
        [DifficultyLevel.EXPERT]: PlaceToNamePlural[PlacesEnum.MOSKINO],
        [DifficultyLevel.GENIUS]: PlaceToNamePlural[PlacesEnum.MONUMENT],
        [DifficultyLevel.LEGEND]: PlaceToNamePlural[PlacesEnum.METRO_STATION],
      },
    },
    staticResources: {
      images: [
        require('../../../assets/images/fragments/BlueBackground.svg').default,
        require('../../../assets/images/fragments/BlueBackgroundTablet.svg').default,
        require('../../../assets/images/fragments/BlueBackgroundMobile.svg').default,
        require('../../../assets/images/fragments/BlueBackgroundDim.svg').default,
        require('../../../assets/images/fragments/BlueBackgroundTabletDim.svg').default,
        require('../../../assets/images/fragments/BlueLostHeader.svg').default,
        require('../../../assets/images/fragments/BlueLostHeaderTablet.svg').default,
        require('../../../assets/images/fragments/BlueLostHeaderMobile.svg').default,
        require('../../../assets/images/fragments/Pin.svg').default,
        require('../../../assets/images/fragments/PinMobile.svg').default,
        require('../../../assets/images/fragments/YellowWinHeader.svg').default,
        require('../../../assets/images/fragments/YellowWinHeaderTablet.svg').default,
        require('../../../assets/images/fragments/YellowWinHeaderMobile.svg').default,
        require('../../../assets/images/fragments/Muted.svg').default,
        require('../../../assets/images/fragments/Unmuted.svg').default,
        require('../../../assets/images/fragments/MutedSmall.svg').default,
        require('../../../assets/images/fragments/UnmutedSmall.svg').default,
      ],
      audio: [require('../../../assets/sounds/paper-flip.wav')],
    },
  },
  metro: {
    icons: {
      [DifficultyLevel.VERY_EASY]: require('../../../assets/images/metro/levels/ballon.svg').default,
      [DifficultyLevel.EASY]: require('../../../assets/images/metro/levels/star.svg').default,
      [DifficultyLevel.MEDIUM]: require('../../../assets/images/metro/levels/fire.svg').default,
      [DifficultyLevel.HARD]: require('../../../assets/images/metro/levels/lightning.svg').default,
      [DifficultyLevel.VERY_HARD]: require('../../../assets/images/metro/levels/flag.svg').default,
      [DifficultyLevel.PRO]: require('../../../assets/images/metro/levels/timer.svg').default,
      [DifficultyLevel.MASTER]: require('../../../assets/images/metro/levels/diamond.svg').default,
      [DifficultyLevel.EXPERT]: require('../../../assets/images/metro/levels/goblet.svg').default,
      [DifficultyLevel.GENIUS]: require('../../../assets/images/metro/levels/medal.svg').default,
      [DifficultyLevel.LEGEND]: require('../../../assets/images/metro/levels/podium.svg').default,
    },
    colors: {
      [DifficultyLevel.VERY_EASY]: { fill: '#FFD12C', underlayFill: '#E09705' },
      [DifficultyLevel.EASY]: { fill: '#00C0FF', underlayFill: '#188DF2' },
      [DifficultyLevel.MEDIUM]: { fill: '#F38FFE', underlayFill: '#C75CD4' },
      [DifficultyLevel.HARD]: { fill: '#FF7760', underlayFill: '#DC5944' },
      [DifficultyLevel.VERY_HARD]: { fill: '#87DC4B', underlayFill: '#51BB24' },
      [DifficultyLevel.PRO]: { fill: '#FF690C', underlayFill: '#C55713' },
      [DifficultyLevel.MASTER]: { fill: '#0FBEA9', underlayFill: '#0A8374' },
      [DifficultyLevel.EXPERT]: { fill: '#E317D5', underlayFill: '#A30BB5' },
      [DifficultyLevel.GENIUS]: { fill: '#8138F6', underlayFill: '#4C13A8' },
      [DifficultyLevel.LEGEND]: { fill: '#57BD0F', underlayFill: '#438B10' },
    },
    text: {
      singular: {
        [DifficultyLevel.VERY_EASY]: 'Очень легкий',
        [DifficultyLevel.EASY]: 'Легкий',
        [DifficultyLevel.MEDIUM]: 'Средний',
        [DifficultyLevel.HARD]: 'Сложный',
        [DifficultyLevel.VERY_HARD]: 'Очень сложный',
        [DifficultyLevel.PRO]: 'Профи',
        [DifficultyLevel.MASTER]: 'Мастер',
        [DifficultyLevel.EXPERT]: 'Эксперт',
        [DifficultyLevel.GENIUS]: 'Гений',
        [DifficultyLevel.LEGEND]: 'Легенда',
      },
    },
    staticResources: {
      images: [
        require('../../../assets/images/metro/difficulty/BackPlan.svg').default,
        require('../../../assets/images/metro/difficulty/BackPlanTablet.svg').default,
        require('../../../assets/images/metro/difficulty/BackPlanMobile.svg').default,
        require('../../../assets/images/metro/difficulty/LeftHouse.svg').default,
        require('../../../assets/images/metro/difficulty/LeftHouseTablet.svg').default,
        require('../../../assets/images/metro/difficulty/RightHouse.svg').default,
        require('../../../assets/images/metro/difficulty/RightHouseTablet.svg').default,
        require('../../../assets/images/metro/MetroWithPeople.svg').default,
        require('../../../assets/images/metro/MetroEmpty.svg').default,
        require('../../../assets/images/metro/difficulty/Trees.svg').default,
        require('../../../assets/images/metro/game/BackPlan.svg').default,
        require('../../../assets/images/metro/game/BackPlanMobile.svg').default,
        require('../../../assets/images/metro/game/BackPlanTablet.svg').default,
        require('../../../assets/images/metro/game/CloseDoor.svg').default,
        require('../../../assets/images/metro/game/LeftHouse.svg').default,
        require('../../../assets/images/metro/game/LeftHouseTablet.svg').default,
        require('../../../assets/images/metro/game/MetroBuilding.svg').default,
        require('../../../assets/images/metro/game/OpenDoor.svg').default,
        require('../../../assets/images/metro/game/RightHouse.svg').default,
        require('../../../assets/images/metro/game/RightHouseTablet.svg').default,
        require('../../../assets/images/metro/game/Tube.svg').default,
        require('../../../assets/images/metro/levels/ballon.svg').default,
        require('../../../assets/images/metro/levels/diamond.svg').default,
        require('../../../assets/images/metro/levels/fire.svg').default,
        require('../../../assets/images/metro/levels/flag.svg').default,
        require('../../../assets/images/metro/levels/goblet.svg').default,
        require('../../../assets/images/metro/levels/lightning.svg').default,
        require('../../../assets/images/metro/levels/medal.svg').default,
        require('../../../assets/images/metro/levels/podium.svg').default,
        require('../../../assets/images/metro/levels/star.svg').default,
        require('../../../assets/images/metro/levels/timer.svg').default,
        require('../../../assets/images/metro/AnswerButtonBackground.svg').default,
        require('../../../assets/images/metro/CloudsBg.svg').default,
        require('../../../assets/images/metro/CloudsBgMobile.svg').default,
        require('../../../assets/images/metro/CloudsBgTablet.svg').default,
        require('../../../assets/images/metro/CountBox.svg').default,
        require('../../../assets/images/metro/firework-1.svg').default,
        require('../../../assets/images/metro/firework-2.svg').default,
        require('../../../assets/images/metro/firework-3.svg').default,
        require('../../../assets/images/metro/firework-4.svg').default,
        require('../../../assets/images/metro/firework-5.svg').default,
        require('../../../assets/images/metro/LostBoard.svg').default,
        require('../../../assets/images/metro/MetroLostBg.svg').default,
        require('../../../assets/images/metro/MetroLostBgMobile.svg').default,
        require('../../../assets/images/metro/MetroLostBgTablet.svg').default,
        require('../../../assets/images/metro/MetroWinHeader.svg').default,
        require('../../../assets/images/metro/UndergroundBg.svg').default,
        require('../../../assets/images/metro/UndergroundBgTablet.svg').default,
        require('../../../assets/images/metro/UndergroundBgMobile.svg').default,
        require('../../../assets/images/metro/WinBoard.svg').default,
      ],
      audio: [],
    },
  },
};

export type TDifficultyAppearance = {
  difficultyLevel: DifficultyLevel;
  icon: string;
  fill: string;
  underlayFill: string;
  isPoints: boolean;
};

export const getDifficultyAppearance = (gameType: TGameType = 'fragments'): TDifficultyAppearance[] => {
  const game = GAME_CONFIG[gameType];
  return Object.values(DifficultyLevel).map((level) => ({
    difficultyLevel: level,
    icon: game.icons[level],
    fill: game.colors[level].fill,
    underlayFill: game.colors[level].underlayFill,
    isPoints: level === DifficultyLevel.LEGEND,
  }));
};

export const commonAssets = {
  images: [
    ...Object.values(GAME_CONFIG.fragments.icons),
    ...Object.values(GAME_CONFIG.metro.icons),
    require('../../../assets/images/fragments/DifficultyFragmentsGamePreview.svg').default,
  ],
  audio: [require('../../../assets/sounds/win-sound.wav'), require('../../../assets/sounds/loose-sound.wav')],
};

export const mapGameToStaticResources: Record<TGameType, { images: string[]; audio: string[] }> = {
  fragments: GAME_CONFIG.fragments.staticResources,
  metro: GAME_CONFIG.metro.staticResources,
};

export const getNextDifficulty = (current: string): DifficultyLevel | null => {
  if (!current) return null;
  const levels = Object.values(DifficultyLevel);
  const currentIndex = levels.indexOf(current as DifficultyLevel);
  return currentIndex !== -1 && currentIndex < levels.length - 1 ? levels[currentIndex + 1] : null;
};

export const FRAGMENTS_GAME_TYPE: TGameType = 'fragments';

export const METRO_GAME_TYPE: TGameType = 'metro';

export const GAME_TYPES = [FRAGMENTS_GAME_TYPE, METRO_GAME_TYPE];

export const reverseLevelMapping: Record<DifficultyLevel, string> = {
  [DifficultyLevel.VERY_EASY]: 'level_1_complete',
  [DifficultyLevel.EASY]: 'level_2_complete',
  [DifficultyLevel.MEDIUM]: 'level_3_complete',
  [DifficultyLevel.HARD]: 'level_4_complete',
  [DifficultyLevel.VERY_HARD]: 'level_5_complete',
  [DifficultyLevel.PRO]: 'level_6_complete',
  [DifficultyLevel.MASTER]: 'level_7_complete',
  [DifficultyLevel.EXPERT]: 'level_8_complete',
  [DifficultyLevel.GENIUS]: 'level_9_complete',
  [DifficultyLevel.LEGEND]: 'level_10_complete',
};

export const levelKeyToDifficulty: Record<string, DifficultyLevel> = {
  level_1: DifficultyLevel.VERY_EASY,
  level_2: DifficultyLevel.EASY,
  level_3: DifficultyLevel.MEDIUM,
  level_4: DifficultyLevel.HARD,
  level_5: DifficultyLevel.VERY_HARD,
  level_6: DifficultyLevel.PRO,
  level_7: DifficultyLevel.MASTER,
  level_8: DifficultyLevel.EXPERT,
  level_9: DifficultyLevel.GENIUS,
  level_10: DifficultyLevel.LEGEND,
};

export const difficultyToLevelKey: Record<DifficultyLevel, string> = Object.fromEntries(
  Object.entries(levelKeyToDifficulty).map(([key, value]) => [value, key]),
) as Record<DifficultyLevel, string>;

// Числовые уровни ("1", "2", ...)
export const numericLevelToDifficulty: Record<string, DifficultyLevel> = Object.fromEntries(
  Object.entries(levelKeyToDifficulty).map(([key, value]) => [key.split('_')[1], value]),
) as Record<string, DifficultyLevel>;

export const difficultyToNumericLevel: Record<DifficultyLevel, string> = Object.fromEntries(
  Object.entries(numericLevelToDifficulty).map(([key, value]) => [value, key]),
) as Record<DifficultyLevel, string>;

// Завершённые уровни (level_1_complete и т.д.)
export const completedLevelKeyToDifficulty: Record<string, DifficultyLevel> = Object.fromEntries(
  Object.entries(levelKeyToDifficulty).map(([key, value]) => [`${key}_complete`, value]),
) as Record<string, DifficultyLevel>;

export const difficultyToCompletedLevelKey: Record<DifficultyLevel, string> = Object.fromEntries(
  Object.entries(completedLevelKeyToDifficulty).map(([key, value]) => [value, key]),
) as Record<DifficultyLevel, string>;
